import { Bar } from "../Charts/Bar";
import { Heatmap } from "../Charts/Heatmap";
import { Line } from "../Charts/Line";
import { Pie } from "../Charts/Pie";
import { Map } from "../Charts/Map";
import { Nav } from "./Nav";
import { londonBoroughsData } from "../../services/Data/Charts/MapData.ts";
import { pieData, series1, series2, series3 } from "../../services/Data/Charts/DataSeries.ts";
import { SideNav } from "../Components/SideNav/SideNav";
import { chartSections } from "../../services/Data/Components/SideNavData.ts";


// TODO: add text to explain the purpose of each chart, what it represents and why it's important
export const Charts = () => {

    return (
        <div className="scroll-smooth">
            <Nav />
            <div className="flex">
                <aside className="flex justify-start h-screen sticky top-0 w-2/12 p-4">
                    <div className="flex justify-evenly gap-4">
                        <SideNav links={chartSections} />
                    </div>
                </aside>

                <section className="w-10/12">
                    <div className="flex justify-start align-middle m-4">
                        <div className="flex justify-start flex-col">
                            <h2 className="text-2xl font-bold">Charts Page</h2>
                            <p>
                                Welcome to the charts and maps page, where you can visualize key data to provide insights and visualise the London property market trends.
                            </p>
                        </div>
                    </div>
                    <div id="maps" className="flex flex-col p-4">
                        <h3 className="text-xl font-bold">Maps</h3>
                        <div className="flex justify-evenly gap-4 flex-wrap">
                            <Map data={londonBoroughsData} title="Map of London" height="575" width="675" />
                            <Map data={londonBoroughsData} title="Map of London 2" height="575" width="675" />
                        </div>
                    </div>

                    <div id="mixed" className="flex flex-col p-4">
                        <h3 className="text-xl font-bold">Bar  font-boldand line</h3>
                        <div className="flex justify-evenly">
                            <Bar data={series1} title="Bar chart" height="400" width="600" />
                            <Line data={series2} title="Line chart" height="400" width="600" />
                        </div>
                    </div>

                    <div id="bars" className="flex flex-col p-4">
                        <h3 className="text-xl font-bold">Bars</h3>
                        <div className="flex justify-evenly mt-12" >
                            <Bar data={series3} title="Bar chart" height="400" width="600" />
                            <Pie data={pieData} title="Bar chart" height="400" width="600" />
                        </div>
                    </div>
                    <div id="heatmap" className="flex flex-col p-4">
                        <h3 className="text-xl font-bold">Heatmap</h3>
                        <div className="flex justify-evenly mt-12" >
                            <Heatmap data={series3} title="Bar chart" height="500" width="1000" />
                        </div>
                    </div>
                </section >
            </div>
        </div>
    );
}